import { Action, Mutation } from './types';

const errorMessages = () => import('../components/message.js');

export default {

    [Action.LOAD_VALIDATION_MESSAGE]({ commit }) {
        errorMessages().then(data => {
            commit(`${[Mutation.SET_VALIDATION_MESSAGE]}`, data.default);
        });
    },   
};
